import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Values } from '../../../../../values/Values';
import Grid from '@material-ui/core/Grid';
import { Line, Pie } from 'react-chartjs-2';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import moment from 'moment';
import Box from '@material-ui/core/Box';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: Values.cores.cinza
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function DialogDetalhesEstatisticasPessoais(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    filiado,
    dados
  } = props;

  const [labelsGraficoModalidades, setLabelsGraficoModalidades] = useState([]);
  const [valoresGraficoModalidades, setValoresGraficoModalidades] = useState([]);
  const [coresGraficoModalidades, setCoresGraficoModalidades] = useState([]);
  const [labelsGraficoInsumos, setLabelsGraficoInsumos] = useState([]);
  const [valoresGraficoInsumos, setValoresGraficoInsumos] = useState([]);
  const [coresGraficoInsumos, setCoresGraficoInsumos] = useState([]);
  const [labelsGraficoVisita, setLabelsGraficoVisitas] = useState([]);
  const [valoresGraficoVisitas, setValoresGraficoVisitas] = useState([]);
  const [coresGraficoVisitas, setCoresGraficoVisitas] = useState([]);
  const ALTURA_CARDS = 500;

  useEffect(() => {
    prepararDadosGraficoModalidades();
    prepararDadosGraficoInsumos();
    prepararDadosGraficoVisitas();
  }, []);

  function prepararDadosGraficoModalidades() {
    for(let i = 0; i < dados.totaisPorModalidade.length; i++){
      labelsGraficoModalidades.push((dados.totaisPorModalidade[i].descricao));
      valoresGraficoModalidades.push(dados.totaisPorModalidade[i].percentual);
      coresGraficoModalidades.push(geraCor());
    }
    setLabelsGraficoModalidades(labelsGraficoModalidades);
    setValoresGraficoModalidades(valoresGraficoModalidades);
    setCoresGraficoModalidades(coresGraficoModalidades);
  }

  function prepararDadosGraficoInsumos() {
    console.log(dados);
    for(let i = 0; i < dados.totaisPorInsumo.length; i++){
      let descricao = dados.totaisPorInsumo[i]['visitaFiliadoMods.visitaFiliadoDisps.insumo.descricao'] ?
        dados.totaisPorInsumo[i]['visitaFiliadoMods.visitaFiliadoDisps.insumo.descricao'] : 'Insumo próprio';
      labelsGraficoInsumos.push(descricao);
      valoresGraficoInsumos.push(dados.totaisPorInsumo[i].percentual);
      coresGraficoInsumos.push(geraCor());
    }
    setLabelsGraficoInsumos(labelsGraficoInsumos);
    setValoresGraficoInsumos(valoresGraficoInsumos);
    setCoresGraficoInsumos(coresGraficoInsumos);
  }

  function prepararDadosGraficoVisitas() {
    for(let i = 0; i < dados.totaisPorvisita.length; i++){
      let descricao = moment(dados.totaisPorvisita[i].dataSaida).format('DD/MM/YYYY');
      labelsGraficoVisita.push(descricao);
      valoresGraficoVisitas.push(dados.totaisPorvisita[i].valorTotal);
    }
    setLabelsGraficoVisitas(labelsGraficoVisita);
    setValoresGraficoVisitas(valoresGraficoVisitas);
  }

  function geraCor(){
    var hexadecimais = '0123456789ABCDEF';
    var cor = '#';
    for (var i = 0; i < 6; i++ ) {
      cor += hexadecimais[Math.floor(Math.random() * 16)];
    }
    return cor;
  }

  const handleClose = () => {
    setOpen(false);
  };
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'My First dataset',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [65, 59, 80, 81, 56, 55, 40]
      }
    ]
  };

  return (

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>

            <Typography variant="h6" className={classes.title} >ESTATÍSTICAS PESSOAIS</Typography>
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={4}
            xs={12}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Box
                  boxShadow={5}
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                >
                  <Card
                    variant={'elevation'}
                    elevation={7}
                    style={{
                      minHeight: ALTURA_CARDS,
                      maxHeight: ALTURA_CARDS
                    }}
                  >
                    <CardHeader
                      title="Modalidades"
                      subheader="Percentual de modalidade mais usadas pelos filiado"
                    />
                    <Divider />
                    <CardContent>
                      <Pie
                        data={{
                          labels: labelsGraficoModalidades,
                          datasets: [{
                            data: valoresGraficoModalidades,
                            backgroundColor: coresGraficoModalidades,
                            hoverBackgroundColor: coresGraficoModalidades
                          }]
                        }}/>
                    </CardContent>
                  </Card>
                </Box>

              </Grid>
            </Grid>

          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Box
                  boxShadow={5}
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                >
                  <Card
                    variant={'elevation'}
                    elevation={7}
                    style={{
                      minHeight: ALTURA_CARDS,
                      maxHeight: ALTURA_CARDS
                    }}
                  >
                    <CardHeader
                    title="Insumos"
                    subheader="Percentual de insumos mais usados pelos filiado"
                  />
                    <Divider />
                    <CardContent>
                    <Pie
                      data={{
                        labels: labelsGraficoInsumos,
                        datasets: [{
                          data: valoresGraficoInsumos,
                          backgroundColor: coresGraficoInsumos,
                          hoverBackgroundColor: coresGraficoInsumos
                        }]
                      }}/>
                  </CardContent>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Box
                  boxShadow={5}
                  style={{
                    marginRight: 10,
                    marginTop: 10,
                  }}
                >
                  <Card
                    variant={'elevation'}
                    elevation={7}
                    style={{
                      minHeight: ALTURA_CARDS,
                      maxHeight: ALTURA_CARDS
                    }}
                  >
                    <CardHeader
                    title="Financeiro"
                    subheader="Valores gastos pelo filiado por visita"
                  />
                    <Divider />
                    <CardContent>
                      <Line
                        options={{
                          scales: {
                            yAxes: [{
                              display: true,
                              ticks: {
                                min: 0,
                              }
                            }]
                          }
                        }}
                        data={
                          {
                            labels: labelsGraficoVisita,
                            datasets: [
                              {
                                label: 'Valor',
                                fill: false,
                                lineTension: 0.3,
                                backgroundColor: 'rgba(75,192,192,0.4)',
                                borderColor: 'rgba(75,192,192,1)',
                                borderCapStyle: 'butt',
                                borderDash: [],
                                borderDashOffset: 0.0,
                                borderJoinStyle: 'miter',
                                pointBorderColor: 'rgba(75,192,192,1)',
                                pointBackgroundColor: '#fff',
                                pointBorderWidth: 1,
                                pointHoverRadius: 20,
                                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                                pointHoverBorderColor: 'rgba(220,220,220,1)',
                                pointHoverBorderWidth: 2,
                                pointRadius: 3,
                                pointHitRadius: 10,
                                data: valoresGraficoVisitas
                              }
                            ]
                          }
                      } />
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
  );
}

export default DialogDetalhesEstatisticasPessoais;
